export const lungsModuleOverview = [
  {
    id: "anatomy",
    title: "Respiratory Anatomy: Part 1",
    description: "Lung lobes, pleurae, bronchopulmonary segments, and hilar anatomy",
    icon: "🫁",
    customImage: "module-lungs-anatomy.png",
    gradient: "from-blue-100 via-sky-50 to-cyan-100 border-blue-300",
  },
  {
    id: "anatomy2",
    title: "Respiratory Anatomy: Part 2",
    description: "Respiratory tree, thoracic wall, diaphragm, and pulmonary vasculature",
    icon: "🌳",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-sky-300",
  },
  {
    id: "histology",
    title: "Respiratory Histology",
    description: "Airway epithelium, alveolar cells, surfactant, and ILD patterns",
    icon: "🔬",
    customImage: "module-lungs-histology.png",
    gradient: "from-green-100 via-emerald-50 to-teal-100 border-green-300",
  },
  {
    id: "physiology",
    title: "Respiratory Physiology: Part 1",
    description: "Lung volumes, spirometry, compliance, airway resistance, and V/Q",
    icon: "⚡",
    gradient: "from-blue-100 via-sky-50 to-cyan-100 border-blue-300",
  },
  {
    id: "physiology2",
    title: "Respiratory Physiology: Part 2",
    description: "O₂/CO₂ transport, gas exchange, ABG interpretation, and respiratory control",
    icon: "🔄",
    customImage: "module-lungs-gas.png",
    gradient: "from-teal-100 via-cyan-50 to-blue-100 border-teal-300",
  },
  {
    id: "disease",
    title: "Obstructive Lung Disease",
    description: "Asthma (GINA, biologics), COPD (GOLD, exacerbations), and bronchiectasis",
    icon: "💨",
    customImage: "module-lungs-respiratory-tree.png",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "disease2",
    title: "Interstitial & Restrictive Lung Disease",
    description: "IPF (anti-fibrotics), sarcoidosis, hypersensitivity pneumonitis, pneumoconioses",
    icon: "🏥",
    gradient: "from-orange-100 via-amber-50 to-yellow-100 border-orange-300",
  },
  {
    id: "disease3",
    title: "Respiratory Infections",
    description: "CAP (CURB-65, atypicals), tuberculosis (HRZE), lung abscess, PCP",
    icon: "🦠",
    gradient: "from-red-100 via-rose-50 to-pink-100 border-red-300",
  },
  {
    id: "disease4",
    title: "Pleural Disease",
    description: "Pneumothorax (BTS guidelines), pleural effusion (Light's), mesothelioma, empyema",
    icon: "🫧",
    gradient: "from-violet-100 via-purple-50 to-indigo-100 border-violet-300",
  },
  {
    id: "disease5",
    title: "Pulmonary Vascular Disease & ARDS",
    description: "PE (Wells, thrombolysis), pulmonary hypertension (WHO groups), ARDS (Berlin, lung-protective ventilation)",
    icon: "🩸",
    gradient: "from-rose-100 via-red-50 to-orange-100 border-rose-300",
  },
  {
    id: "disease6",
    title: "Lung Cancer",
    description: "NSCLC subtypes, EGFR/ALK/ROS1 targeted therapy, staging (TNM8), immunotherapy, screening",
    icon: "🎗️",
    gradient: "from-gray-100 via-slate-50 to-zinc-100 border-gray-300",
  },
  {
    id: "pharmacology",
    title: "Respiratory Pharmacology: Inhaled Therapy",
    description: "SABAs, LABAs, LAMAs, ICS, combination inhalers, methylxanthines, LTRAs",
    icon: "💊",
    gradient: "from-emerald-100 via-green-50 to-teal-100 border-emerald-300",
  },
  {
    id: "pharmacology2",
    title: "Respiratory Pharmacology: Systemic Agents",
    description: "Biologics (omalizumab, mepolizumab, dupilumab), anti-fibrotics, PAH drugs, anti-TB, CFTR modulators",
    icon: "💉",
    gradient: "from-cyan-100 via-teal-50 to-green-100 border-cyan-300",
  },
  {
    id: "surgery",
    title: "Thoracic Surgery: Approaches & Resections",
    description: "VATS vs open, preoperative assessment (ppo FEV₁, CPEX), lobectomy, pneumonectomy",
    icon: "🔧",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-sky-300",
  },
  {
    id: "surgery2",
    title: "Thoracic Surgery: Procedures & Complications",
    description: "Chest drains, bronchoscopy (EBUS, TBLC), pleurodesis, lung transplantation, post-op complications",
    icon: "🏗️",
    gradient: "from-indigo-100 via-violet-50 to-purple-100 border-indigo-300",
  },
];
